import SimplexNoise from "simplex-noise";
import React, { useRef, useState, useEffect } from "react";

let animationId = 0;

// X 轴位置
let xoff = 0;
let xinc = 0.05;
// 波纹速度
let yoff = 0;
let yinc = 0.01;
// 增量高度起伏
let goff = 0;
let ginc = 0;

interface WaveProps {
    className?: string,
    style?: React.CSSProperties,
    width: number,
    height: number,
    bgColor?: string,
    waveHeight?: number,
    waveColor?: Array<string>,
}

function Wave(props: WaveProps) {

    let { className, style, width, height, waveHeight = 0, bgColor = "#f1dfdd", waveColor = ["#fb0000", "#00ff8e", "#6F33FF"] } = props;

    if (!waveHeight) waveHeight = height;

    let canvas = useRef<any>()
    let [ctx, setCtx] = useState<any>(null)

    let [simplex] = useState(new SimplexNoise())

    let cx = width / 2;
    // 波浪频率
    let count = Math.floor(width / 10);
    let length = width + 0;

    // amp 起伏的高度区间
    let wave = function (color: string, amp: number, height: number, comp: string) {
        ctx.beginPath();
        var sway = simplex.noise2D(goff, 0) * amp;

        for (var i = 0; i <= count; i++) {
            xoff += xinc;
            var x = cx - length / 2 + length / count * i;
            var y = height + simplex.noise2D(xoff, yoff) * amp + sway;
            ctx[i === 0 ? 'moveTo' : 'lineTo'](x, y);
        }

        ctx.lineTo(width, -height); // -height - Vertically reflection
        ctx.lineTo(0, -height); // -height - Vertically reflection
        ctx.closePath();
        ctx.fillStyle = color;

        if (comp) {
            ctx.globalCompositeOperation = comp;
        }

        ctx.fill();
    };

    let loop = function () {
        animationId = requestAnimationFrame(loop);

        ctx.clearRect(0, 0, width, height);

        // 每次都要重头开始画
        xoff = 0;

        ctx.fillStyle = "#182645";
        ctx.fillRect(0, 0, width, height);

        for (let color of waveColor) {
            wave(color, 20, height - waveHeight + 20, "screen");
        }
        // wave("#00ff8e", 20, height - waveHeight + 20, "screen");
        // wave("#6F33FF", 20, height - waveHeight + 20, "screen");

        ctx.fillStyle = bgColor;

        ctx.globalCompositeOperation = "darken";

        ctx.fillRect(0, 0, width, height);

        yoff += yinc;
        goff += ginc;
    };

    useEffect(() => {
        if (canvas.current) {
            setCtx(canvas.current.getContext('2d'));
        }
    }, [canvas])

    useEffect(() => {
        if (ctx) {
            cancelAnimationFrame(animationId)
            loop();
        }
    }, [ctx, width])

    return <canvas className={className} style={style} ref={canvas} width={width} height={height}></canvas>
}

export default Wave;